define('app-CarouselComponent/modules',['./settings'],
    function () {
        return {

            sliderControls: function (slideshow) {

                if ($(slideshow).hasClass('owl-carousel')) {
                    var elCarouselItem = $('.owl-item');
                    if (!$(".counter", slideshow).hasClass('populated')) {
                        $("<div>").addClass('counter').insertAfter($(".owl-prev", slideshow));
                    }
                    var elCarouselCounter = $('.counter');
                    var currentIndex = slideshow.find('.owl-item.active:last').index() + 1;
                    var ti = slideshow.find(elCarouselItem).length;
                    
                    if (ti >= 2) {

                        slideshow.find('.counter').addClass('populated');
                        slideshow.find(elCarouselCounter).html('' + currentIndex + ' of ' + ti + '');

                    }
                }
                else {
                    var elCarouselItem = $('.carousel-item');
                    var elCarouselCounter = $('.counter');
                    var currentIndex = slideshow.find('.carousel-item.active').index() + 1;
                    var ti = slideshow.find(elCarouselItem).length;

                    if (ti >= 2) {
                        slideshow.find('.carousel-control-holder').addClass('showControls');
                        slideshow.find(elCarouselCounter).html('' + currentIndex + ' of ' + ti + '');

                        if (!(slideshow).hasClass('controlWrap')) {

                            if (currentIndex == 1) {
                                slideshow.find('.carousel-control-prev').addClass('disabled');
                                slideshow.find('.carousel-control-next').removeClass('disabled');
                            } else if (currentIndex == ti) {
                                slideshow.find('.carousel-control-next').addClass('disabled');
                                slideshow.find('.carousel-control-prev').removeClass('disabled');
                            }
                            else {
                                slideshow.find('.carousel-control-prev').removeClass('disabled');
                                slideshow.find('.carousel-control-next').removeClass('disabled');
                            }
                        }

                    }
                }

            }

        }
    }
);


